/* ============================================================
   PURE DÉTAIL — Effets visuels (TEST 2026-10-14) — voir assets/pd-effets.css
   (Les barres de livraison gratuite existent déjà dans pd-premium.js ; ici seulement le reflet, en CSS.)
   ============================================================ */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var ready = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };
  var isVisible = function (el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth && getComputedStyle(el).visibility !== 'hidden';
  };

  /* ---------- 1 + 2. Cartes : reflet + inclinaison 3D ---------- */
  var CARD_SEL = '.product__grid-item .product-wrap, .collection-list__thumbnail .product-wrap';
  var shineIO = (!FINE && !RM && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('pd-shine-once'); shineIO.unobserve(en.target); }
    });
  }, { threshold: .6 }) : null;

  function prepCard(card) {
    if (card.__pdfx) return;
    card.__pdfx = 1;
    card.classList.add('pd-fx-card');
    var fx = document.createElement('span');
    fx.className = 'pd-fx-layer';
    fx.setAttribute('aria-hidden', 'true');
    card.appendChild(fx);
    if (shineIO) shineIO.observe(card); // mobile : un reflet quand la carte apparaît
    if (!FINE || RM) return;
    var raf = 0;
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.setProperty('--pd-rx', ((0.5 - y) * 8).toFixed(2) + 'deg');
        card.style.setProperty('--pd-ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
        card.style.setProperty('--pd-gx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--pd-gy', (y * 100).toFixed(1) + '%');
        card.classList.add('is-tilting');
      });
    });
    card.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      card.classList.remove('is-tilting');
      card.style.setProperty('--pd-rx', '0deg');
      card.style.setProperty('--pd-ry', '0deg');
    });
  }

  // Seulement les boutons-liens du site (.pd-btn). Jamais les boutons du thème comme « Ajouter au chariot » :
  // le thème réécrit le texte de leur dernier élément (le reflet de ceux-là est en CSS seulement).
  function prepButtons(root) {
    root.querySelectorAll('.pd-btn').forEach(function (b) {
      if (b.querySelector(':scope > .pd-btn-shine')) return;
      b.classList.add('pd-shine-host');
      if (b.matches('.pd-btn--red') && !RM) b.classList.add('pd-shine-auto');
      var s = document.createElement('span');
      s.className = 'pd-btn-shine';
      s.setAttribute('aria-hidden', 'true');
      b.appendChild(s);
    });
  }

  function scan() {
    document.querySelectorAll(CARD_SEL).forEach(prepCard);
    prepButtons(document);
  }

  /* ---------- 3. Gouttes d'eau perlantes ---------- */
  function beads(host, shade) {
    if (!host || host.querySelector('.pd-beads')) return;
    var cv = document.createElement('canvas');
    cv.className = 'pd-beads';
    cv.setAttribute('aria-hidden', 'true');
    shade.parentNode.insertBefore(cv, shade.nextSibling);
    var z = getComputedStyle(shade).zIndex;
    if (z !== 'auto') cv.style.zIndex = z;
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, drops = [], t0 = 0, last = 0, visible = false, raf = 0;

    function make(t, top) {
      var big = Math.random() < 0.09;
      var r = big ? 3.5 + Math.random() * 5.5 : 0.8 + Math.pow(Math.random(), 2) * 3.2;
      var y = top ? Math.random() * H * 0.4 : Math.random() * H;
      return {
        x: W * Math.pow(Math.random(), 0.55), y: y, y0: y, r: r, sx: 0.85 + Math.random() * 0.3,
        born: t + Math.random() * 2600,
        slide: big && Math.random() < 0.55 ? { at: 3200 + Math.random() * 6000, v: 0 } : null
      };
    }
    function size() {
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      W = host.clientWidth; H = host.clientHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.min(520, Math.round(W * H / 2900));
      drops = [];
      for (var i = 0; i < n; i++) drops.push(make(0, false));
      if (RM) { drops.forEach(function (p) { p.born = -1e9; p.slide = null; }); draw(1e9); }
    }
    function drop(p, a) {
      var r = p.r * (0.55 + 0.45 * a);
      ctx.save();
      ctx.globalAlpha = a;
      ctx.translate(p.x, p.y);
      ctx.scale(p.sx, 1);
      if (r < 1.3) {
        ctx.beginPath(); ctx.arc(0, 0, r, 0, 6.283); ctx.fillStyle = 'rgba(255,255,255,.38)'; ctx.fill();
        ctx.restore(); return;
      }
      ctx.beginPath(); ctx.arc(r * 0.16, r * 0.3, r, 0, 6.283); ctx.fillStyle = 'rgba(0,0,0,.32)'; ctx.fill();
      var g = ctx.createRadialGradient(0, r * 0.4, r * 0.05, 0, 0, r);
      g.addColorStop(0, 'rgba(255,255,255,.26)');
      g.addColorStop(0.65, 'rgba(255,255,255,.05)');
      g.addColorStop(1, 'rgba(255,255,255,.4)');
      ctx.beginPath(); ctx.arc(0, 0, r, 0, 6.283); ctx.fillStyle = g; ctx.fill();
      ctx.beginPath(); ctx.ellipse(-r * 0.3, -r * 0.4, r * 0.34, r * 0.2, -0.6, 0, 6.283); ctx.fillStyle = 'rgba(255,255,255,.9)'; ctx.fill();
      ctx.beginPath(); ctx.arc(r * 0.35, r * 0.45, r * 0.12, 0, 6.283); ctx.fillStyle = 'rgba(255,255,255,.45)'; ctx.fill();
      ctx.restore();
    }
    function draw(t) {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < drops.length; i++) {
        var p = drops[i];
        var age = t - p.born;
        if (age < 0) continue;
        if (p.slide && age > p.slide.at) {
          p.slide.v = Math.min(p.slide.v + 0.004, 0.32);
          p.y += p.slide.v * 16;
          p.x += Math.sin((p.y + p.born) / 40) * 0.25;
          var tg = ctx.createLinearGradient(0, p.y0, 0, p.y);
          tg.addColorStop(0, 'rgba(255,255,255,0)');
          tg.addColorStop(1, 'rgba(255,255,255,.14)');
          ctx.fillStyle = tg;
          ctx.fillRect(p.x - p.r * 0.35, p.y0, p.r * 0.7, Math.max(0, p.y - p.y0));
          if (p.y - p.r > H) { drops[i] = make(t, true); continue; }
        }
        drop(p, Math.min(1, age / 500));
      }
    }
    function loop(ts) {
      if (!visible) { raf = 0; return; }
      if (!t0) t0 = ts;
      if (ts - last > 30) { last = ts; draw(ts - t0); }
      raf = requestAnimationFrame(loop);
    }
    size();
    window.addEventListener('resize', function () { clearTimeout(cv.__rt); cv.__rt = setTimeout(size, 250); });
    if (RM) return;
    new IntersectionObserver(function (en) {
      visible = en[0].isIntersecting;
      if (visible && !raf) raf = requestAnimationFrame(loop);
    }).observe(host);
  }

  /* ---------- 4. Compteurs (section pd-stats) ---------- */
  function counters() {
    var els = document.querySelectorAll('[data-pd-count]');
    if (!els.length || RM || !('IntersectionObserver' in window)) return;
    var fmt = function (n) { return n.toLocaleString('fr-CA'); };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, to = parseFloat(el.getAttribute('data-pd-count')) || 0, start = 0;
        var step = function (ts) {
          if (!start) start = ts;
          var k = Math.min(1, (ts - start) / 1800), e = 1 - Math.pow(1 - k, 4);
          el.textContent = fmt(Math.round(to * e));
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: .5 });
    els.forEach(function (el) { el.textContent = '0'; io.observe(el); });
  }

  /* ---------- 6. Produit qui vole vers le panier ---------- */
  function cartIcon() {
    var list = document.querySelectorAll('.header-cart__icon, .header-cart, a.header__link[href="/cart"], a[href="/cart"]');
    for (var i = 0; i < list.length; i++) if (isVisible(list[i]) && !list[i].closest('.ajax-cart, .cart-section')) return list[i];
    return null;
  }
  function findImg(btn) {
    var n = btn;
    for (var i = 0; i < 14 && n && n !== document.body; i++) {
      n = n.parentElement;
      if (!n || n === document.body) break;
      var imgs = [].filter.call(n.querySelectorAll('img'), function (m) {
        return m.getBoundingClientRect().width > 60 && isVisible(m) && !m.closest('header, .header, #header, .mobile-header, .ajax-cart');
      });
      if (imgs.length) {
        imgs.sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return rb.width * rb.height - ra.width * ra.height; });
        return imgs[0];
      }
    }
    return null;
  }
  function fly(btn) {
    var img = findImg(btn), src = img || btn;
    var r = src.getBoundingClientRect();
    var t = cartIcon();
    var tr = t ? t.getBoundingClientRect() : { left: innerWidth - 52, top: 18, width: 32, height: 32 };
    var size = img ? Math.min(r.width, r.height, 200) : 26;
    var x0 = r.left + r.width / 2 - size / 2, y0 = r.top + r.height / 2 - size / 2;
    var el = document.createElement('div');
    el.className = 'pd-fly' + (img ? '' : ' pd-fly--dot');
    if (img) el.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    el.style.left = x0 + 'px'; el.style.top = y0 + 'px';
    el.style.width = size + 'px'; el.style.height = size + 'px';
    document.body.appendChild(el);
    var dx = tr.left + tr.width / 2 - (x0 + size / 2), dy = tr.top + tr.height / 2 - (y0 + size / 2);
    var anim = el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '16px' },
      { transform: 'translate(' + dx * 0.3 + 'px,' + (dy * 0.3 - 110) + 'px) scale(.55)', opacity: 1, borderRadius: '50%', offset: 0.42 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: 0.35, borderRadius: '50%' }
    ], { duration: 900, easing: 'cubic-bezier(.55,0,.35,1)' });
    anim.onfinish = function () {
      el.remove();
      if (t) { t.classList.remove('pd-cart-bump'); void t.offsetWidth; t.classList.add('pd-cart-bump'); }
    };
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"], [data-add-to-cart-trigger], .button--add-to-cart');
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true' || RM || !Element.prototype.animate) return;
    fly(b);
  }, true);

  /* ---------- Démarrage ---------- */
  ready(function () {
    scan();
    counters();
    // Gouttes : seulement la bannière « Protection & brillance » (retirées de l'accueil à la demande du client)
    if (/\/collections\/protection-brillance/.test(location.pathname)) {
      var ph = document.querySelector('.pd-page-hero');
      if (ph && ph.querySelector('.pd-page-hero__shade')) beads(ph, ph.querySelector('.pd-page-hero__shade'));
    }
    // Contenu chargé plus tard (filtres, « charger plus », mini-panier) : on prépare les nouvelles cartes
    var mt;
    new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(scan, 250); }).observe(document.body, { childList: true, subtree: true });
  });
})();
